import clsx from 'clsx';
import PropTypes from 'prop-types';

function CardInput({ as, checked, children, disabled, extendedStyles, inputAttributes }) {
    const { handleChange, name, value } = inputAttributes ?? {};

    return (
        <div
            className={clsx(
                'flex flex-col justify-center rounded-md',
                {
                    'border border-grey-light focus-within:outline focus-within:outline-kale focus-within:if:border-beet':
                        !checked,
                    'border border-transparent shadow-[0_0_0_2px] shadow-kale if:shadow-beet': checked,
                    'bg-lime if:bg-strawberry': checked && !disabled,
                    'bg-white': !checked && !disabled,
                    'bg-grey-light': disabled,
                },
                extendedStyles.wrapper
            )}
        >
            <label
                className={clsx('block  p-5', {
                    'cursor-pointer': !disabled,
                    'cursor-not-allowed': disabled,
                })}
            >
                {children}
                <input
                    className="sr-only"
                    checked={checked}
                    disabled={disabled}
                    name={name}
                    onChange={() => handleChange(value)}
                    type={as}
                    value={value}
                />
            </label>
        </div>
    );
}

CardInput.propTypes = {
    as: PropTypes.oneOf(['radio', 'checkbox']),
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    extendedStyles: PropTypes.shape({ wrapper: PropTypes.string }),
    inputAttributes: PropTypes.shape({
        handleChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }).isRequired,
};

CardInput.defaultProps = {
    as: 'radio',
    checked: false,
    disabled: false,
    extendedStyles: {},
};

export default CardInput;
